/**
 * Scripts that are tightly coupled to the index template
 *
 * Compiles to ./dist/assets/scripts/template.index.js
 */

import { load } from '@shopify/theme-sections';
import '../sections/sliderButtons';

load('*');
